import axios from "axios";
import {
  REACT_APP_ELASTIC_AUTH_TOKEN,
  REACT_APP_ELASTIC_URL,
} from "../constant/environment";
import dateFormat from "dateformat";

const headers = {
  headers: {
    "content-type": "application/x-ndjson",
    authorization: `Basic ${REACT_APP_ELASTIC_AUTH_TOKEN}`,
  },
};

export const getUser = async () => {
  const url = `${REACT_APP_ELASTIC_URL}/visitors/_doc/${localStorage.getItem(
    "visitorId"
  )}`;

  try {
    const response = await axios.get(url, headers);
    return { data: response.data._source, success: true };
  } catch (error) {
    return { data: error.message, success: false };
  }
};

// export const deleteUser = async (payload) => {
//   const url = `${REACT_APP_ELASTIC_URL}/visitors/_doc/${localStorage.getItem(
//     "visitorId"
//   )}`;
//   try {
//     const { data } = await axios.put(url, payload, headers);
//     if (data.result === "updated") return { success: true };
//     return { success: false };
//   } catch (error) {
//     return { success: false };
//   }
// };

export const deleteUser = async (payload) => {
  const url = `${REACT_APP_ELASTIC_URL}/visitors/_update/${localStorage.getItem("visitorId")}`;
  try {
    const { data } = await axios.post(url, {"doc":payload,"doc_as_upsert": true}, headers);
    if (data.result === "updated" || data.result === "created" ) return { success: true };
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

// export const putFonts = async (fonts) => {
//   const url = `${REACT_APP_ELASTIC_URL}/visitors/_doc/${localStorage.getItem(
//     "visitorId"
//   )}`;

//   const payload = {
//     likedPair: fonts,
//     createdAt: dateFormat(new Date(), "mmmm d, yyyy"),
//   };

//   const { data, success } = await getUser();

//   if (!success) {
//     const pairs = { likedPairs: [payload] };
//     await axios.put(url, pairs, headers);
//     return pairs.likedPairs;
//   }

//   const index =
//     data?.likedPairs &&
//     Array.isArray(data?.likedPairs) &&
//     data?.likedPairs?.findIndex(
//       (item) => item?.likedPair?.toString() === payload?.likedPair?.toString()
//     );

//   if (index === -1) {
//     const pairs = { likedPairs: [...data.likedPairs, payload] };
//     await axios.put(url, pairs, headers);
//     return pairs.likedPairs;
//   }

//   if(Object.keys(data).length === 0) {
//     const pairs = { likedPairs: [payload] };
//     await axios.put(url, pairs, headers);
//     return pairs.likedPairs;
//   }
// };
export const putFonts = async (fonts,dislikedPairs) => {
  const url = `${REACT_APP_ELASTIC_URL}/visitors/_update/${localStorage.getItem(
    "visitorId"
  )}`;

  const payload = {
    likedPair: fonts,
    createdAt: dateFormat(new Date(), "mmmm d, yyyy"),
  };

  const { data, success } = await getUser();

  if (!success) {
    const pairs = { likedPairs: [payload] };
    await axios.post(url, {"doc":{likedPairs: [payload],dislikedPairs}, "doc_as_upsert": true}, headers);
    return pairs.likedPairs;
  }

  const index =
    data?.likedPairs &&
    Array.isArray(data?.likedPairs) &&
    data?.likedPairs?.findIndex(
      (item) => item?.likedPair?.toString() === payload?.likedPair?.toString()
    );

  if (index === -1) {
    const pairs = { likedPairs: [...data.likedPairs, payload] };
    await axios.post(url, {"doc":{likedPairs: [...data.likedPairs, payload], dislikedPairs},"doc_as_upsert": true}, headers);
    return pairs.likedPairs;
  }

  if(Object.keys(data).length === 0) {
    const pairs = { likedPairs: [payload] };
    await axios.post(url, {"doc":{likedPairs: [payload], dislikedPairs},"doc_as_upsert": true}, headers);
    return pairs.likedPairs;
  }
};
